import { defineStore } from "pinia";
import $http from "@/utils/request";
import { MerchantConfigs, type MerchantInfo } from "@/constants/merchantInfo";

export const homerStore = defineStore("home", {
  state: () => ({
    billList: [],
    // 半流程资方完整数据，由接口 /app/find-semi-process-list 动态获取
    semiProcessList: [] as any[],
  }),
  getters: {
    thirdPartyMerchantSet(): Set<string> {
      return new Set(this.semiProcessList.map((item: any) => item.code));
    },
    merchantConfigMap(): Record<string, MerchantInfo> {
      // 全流程（硬编码）打底，半流程（接口）覆盖
      const map: Record<string, MerchantInfo> = { ...MerchantConfigs };
      for (const item of this.semiProcessList) {
        const supportLine = (item.supportLine || "").trim();
        map[item.code] = {
          phoneNumberShow: supportLine,
          phoneNumber: supportLine.replace(/[-\s]/g, ""),
          customerTime: item.supportLineTime ? `客服时间：${item.supportLineTime}` : undefined,
        };
      }
      console.log("merchantConfigMap11-->", map);
      return map;
    },
  },
  actions: {
    changeBillList(billList: any) {
      this.billList = billList;
    },
    async fetchThirdPartyMerchants(force = false) {
      // if (!force && this.semiProcessList.length > 0) return;
      try {
        const res: any = await $http.get("/app/find-semi-process-list");
        if (res?.code == 0 && Array.isArray(res.data)) {
          this.semiProcessList = res.data;
        } else {
          console.error("获取半流程资方列表失败-->", res);
        }
      } catch (e) {
        console.error("获取半流程资方列表失败", e);
      }
    },
  },
  persist: {
    key: "store-home",
    storage: sessionStorage, // 使用 sessionStorage 存储，关闭浏览器后清除
    paths: ["billList", "semiProcessList"], // 指定持久化的值
  },
});
